<template>
	<section class="page">
		<h3>普通用户管理</h3>

		<div class="content-box">
			<div class="operator">
				<div class="operator-col">
					<el-button
						size="mini"
						type="primary"
						@click="handleCreate()"
						v-loading="loadings.create"
						>新建</el-button
					>
				</div>
				<div class="operator-col">
					<el-input
						size="mini"
						v-model="filterTableSearch"
						placeholder="姓名/手机号"
						suffix-icon="el-icon-search"
						clearable
					></el-input>
				</div>
			</div>
			<curd-table
				ref="listTable"
				:data-model="editorDataModel"
				:fields="tableFields"
				:expand-fields="tableFieldsExpand"
				:search-filter="filterTableSearch"
				:kv-filter="kvFilter"
				:list-ops="listOps"
				@goaddress="handlerGoAddress($event)"
				@sendVoucher="handlerSendVoucher"
				@doedit="handleEdit($event)"
			></curd-table>
		</div>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
		></editor>
		<el-dialog :visible.sync="sendVoucherVisible" :append-to-body="true" title="赠券">
			<div v-if="sendVoucher.user">
				<div>赠送给 {{ sendVoucher.user.name }}</div>
				<div>
					<voucher-input v-model="sendVoucher.voucher" size="mini"></voucher-input>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="sendVoucherVisible = false">取 消</el-button>
				<el-button size="mini" type="primary" @click="doConfirmSendVoucher()"
					>确 定</el-button
				>
			</div>
		</el-dialog>
	</section>
</template>

<script>
import Charge from "@/views/Customer/subs/Charge.vue";
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import TabPage from "@/mixins/TabPage.js";
import VoucherInput from "@/widgets/Inputs/VoucherInput.vue";

export default {
	mixins: [CurdPage, Filters, TabPage],
	components: { VoucherInput },

	data() {
		return {
			editorDataModel: "Customer",
			hisDataModel: "Balanceflow",
			filterTableSearch: "",
			filterAgent_level: { field: "agent_level", index: null },
			tableFields: [
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: "phone",
					sortable: "custom",
				},
        {
          name: "credits",
          sortable: "custom",
        },
				{
					name: "agent_level",
					sortable: "custom",
				},
        {
          name: "vip_ts",
          sortable: "custom",
        },
        {
          name: "vip_credits",
          sortable: "custom",
        },
				{
					name: "country_code",
					sortable: "custom",
				},
				{
					name: "intro",
					sortable: "custom",
				},
			],
			tableFieldsExpand: [
				{
					name: "intro",
					isTag: true,
				},
				{
					name: "street",
					isTag: true,
				},
				{
					name: "reg_ts",
					sortable: "custom",
				},
			],
			editorFields: [
				{
					name: "name",
					col: 6,
					rules: ["required"],
				},

				{
					name: "phone",
					col: 6,
					rules: ["required"],
				},
				{
					name: "password",
					col: 6,
				},
				{
					name: "type",
					col: 6,
				},
				{
					name: "agent_level",
					col: 6,
				},
				{
					name: "country_code",
					col: 6,
				},
				{
					name: "province",
					col: 6,
				},

				{
					name: "street",
					width: "100%",
					row: 3,
				},
				{
					name: "intro",
					width: "100%",
					row: 3,
				},
			],
			chargeTableFields: [
				{
					name: "customer",
					sortable: "custom",
					isBold: true,
				},
				{
					name: "type",
					sortable: "custom",
				},
				{
					name: "amount",
					sortable: true,
				},
				{
					name: "created_at",
					sortable: true,
				},
			],
			chargeExpandTableFields: [
				{
					name: "type",
				},
				{
					name: "balance",
				},
				{
					name: "amount",
				},
				{
					name: "desc",
				},
				{
					name: "primary_img",
				},
			],
			listOps: [
				{
					name: "edit",
					show_name: "编辑",
					handler: "doedit",
				},
				{
					name: "editAddress",
					show_name: "详情",
					handler: "goaddress",
				},
				{
					name: "sendVoucher",
					show_name: "赠券",
					handler: "sendVoucher",
				},
			],
			sendVoucherVisible: false,
			sendVoucher: {
				user: null,
				voucher: {
					_id: "",
					name: "",
				},
			},
		};
	},
	computed: {},
	created() {},
	mounted() {
		this.refreshRoute();
	},
	methods: {
		refreshRoute(tab = null) {
			if (!tab) {
				this.activeName = this.$route.params.tab;
			} else {
				this.activeName = tab;
			}
		},
		handlerGoAddress(id) {
			this.$router.push({
				name: "Customer-User-Show",
				params: {
					id: id,
				},
			});
		},
		handlerSendVoucher(id, data) {
			this.sendVoucher.user = data;
			this.sendVoucherVisible = true;
		},
		doConfirmSendVoucher() {
			console.log(this.sendVoucher.user, this.sendVoucher.voucher);
			const data = {
				customer: { _id: this.sendVoucher.user._id },
				voucher: { _id: this.sendVoucher.voucher._id },
			};
			this.$axios
				.post(`/customer/do_send_voucher/`, data)
				.then((json) => {
					this.loadings.main = false;
					this.$message.success("成功");
					this.sendVoucherVisible = false;
				})
				.catch((json) => {
					this.loadings.main = false;
					this.$message.error(json.data.msg);
				});
		},
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: {
			handler(val) {
				if (val) {
					this.refreshRoute();
				}
			},
			immediate: true,
			deep: true,
		},
		"filterAgent_level.value": {
			handler(newVal) {
				let val = this.filterAgent_level;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
